export default __webpack_public_path__ + "bd6d0ac6aa360eb24936d9a3e771d388.png";